// Module generated from Markdown by Markdown Component Loader v1.1.0
import React from 'react';
import PropTypes from 'prop-types';

MarkdownComponent.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object
};

function MarkdownComponent(props) {
  const { className, style } = props;

  return (
    <div className={className} style={style}>
      <p>The legacy API endpoints and this legacy documentation page were disabled on October 1, 2019 and are no longer accessible. Please use the <a href="/explore/health/docs/fhir">FHIR Veterans Health API</a>.</p>
    </div>
  );
};

export default MarkdownComponent;
